/*
  isAllDataFromCurrentOrSameYear can be:
    1) isAllDataFromCurrentYear --> this is in general for tooltip
    2) isAllDataFromSameYear --> this is usually for xAxisDateTimeLabel
*/
export function getDateTimeLabelFormatsForTooltips(
    isAllDataFromCurrentOrSameYear: boolean = false,
    shortYear: boolean = true,
    dataLevel?: string
) {
    const dayStr = '%e';
    const yearStr = isAllDataFromCurrentOrSameYear ? '' : shortYear ? " '%y" : '%Y';
    const monthStr = dataLevel === 'quarters' ? '%Q' : '%B';

    return {
        dayStr,
        monthStr,
        yearStr
    };
}
